import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';

const useFetchTourFeatured = (city = null) => {

    const [isLoading, setIsLoading] = React.useState(false);
    const [tours, setTours] = React.useState([]);
    const [error, setError] = React.useState(null);
    const { i18n } = useTranslation();

    const fetchTourFeatured = React.useCallback(async () => {
        setIsLoading(true)
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');
        const params = {
            city: city,
            lng: i18n.language
        }


        try {
            const { data } = await axios.get(
                `${REACT_APP_BASE_URL}/index.php?r=api/tours/tourfeatured`,
                {
                    headers: {
                        'x-authorization-token': token
                    },
                    params: params
                }
            )

            setIsLoading(false)

            if (data?.tours) {
                setTours(data.tours)
            }
        } catch (err) {
            console.error('Error fetching tours featured ', err)
            setError(true)
            setIsLoading(false)
        }

    }, [city])
    //
    React.useEffect(() => {
        fetchTourFeatured();
    }, [fetchTourFeatured]);

    return {
        tours,
        isLoading,
        error
    }
}

export default useFetchTourFeatured


// data json example

// {
//     "status": "success",
//     "message": "Tour List",
//     "code": "200",
//     "count": 10,
//     "priceRange": {
//         "marks": [
//             {
//                 "value": 0,
//                 "label": "Free"
//             },
//             {
//                 "value": 1800,
//                 "label": "1800€"
//             }
//         ],
//         "max": 1800,
//         "min": 0,
//         "ariaLabel1": "Minimum price",
//         "ariaLabel2": "Maximum price"
//     },
//     "tours": [
//         {
//             "price": {
//                 "from": 1718.67,
//                 "currency": "€",
//                 "iva": 1
//             },
//             "name": "Toledo y Segovia en un día desde Madrid Tour Privado",
//             "slug": "tour-por-las-calles-de-madrid",
//             "city_slug": "madrid",
//             "images": "https://s3.amazonaws.com/images.trekzy.com/2024/11/14/c90d49a8-73e0-4ce8-affd-d8479e2dd3a6/L/toledosegovia-17.jpg",
//             "shortDescription": "Explora Toledo y Segovia, sitios del Patrimonio Mundial de la UNESCO, con visitas a lugares icónicos como la Catedral de Toledo, el Acueducto de Segovia y el Alcázar.",
//             "continent": {
//                 "name": "Europa",
//                 "slug": "europa"
//             },
//             "country": {
//                 "name": "España",
//                 "slug": "espana"
//             },
//             "region": {
//                 "name": "Comunidad de Madrid",
//                 "slug": "comunidad-de-madrid"
//             },
//             "city": {
//                 "name": "Madrid",
//                 "slug": "madrid"
//             },
//             "operator": "Amigo Tours",
//             "scores": {
//                 "score": "9.5",
//                 "stars": "4.5"
//             },
//             "duration": {
//                 "duration": "11",
//                 "type": "horas"
//             },
//             "reviewsTotal": 1060,
//             "availabilityDays": [
//                 {
//                     "day": 0,
//                     "name": "Domingo"
//                 },
//                 {
//                     "day": 0,
//                     "name": "Domingo"
//                 },
//                 {
//                     "day": 1,
//                     "name": "Lunes"
//                 },
//                 {
//                     "day": 2,
//                     "name": "Martes"
//                 },
//                 {
//                     "day": 3,
//                     "name": "Miércoles"
//                 },
//                 {
//                     "day": 4,
//                     "name": "Jueves"
//                 },
//                 {
//                     "day": 5,
//                     "name": "Viernes"
//                 },
//                 {
//                     "day": 6,
//                     "name": "Sábado"
//                 }
//             ],
//             "freeCancelation": 1,
//             "languages": [
//                 {
//                     "language": "Español",
//                     "currency": "€"
//                 },
//                 {
//                     "language": "Inglés",
//                     "code": "en"
//                 }
//             ]
//         }
//     ]
// }